module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iiJJl"))).then(() => parcelRequire('2KbAe'));